<template>
    <ValidationObserver ref="form">
        <div class="form">

            <AdditionalQuestionsForm
                :user="user"
                @data-changed="updateForm"
            ></AdditionalQuestionsForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-9"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <button
                                @click="save"
                                class="btn btn--secondary w-100 w-sm-auto"
                            >
                                apply
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import AdditionalQuestionsForm from "../CommonForms/AdditionalQuestionsForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: 'ApplicantFormStep10',
    components: { AdditionalQuestionsForm},
    props: {
        user: {
            type:Object
        }
    },
    data() {
        return {
            dataFormStep10: {}
        }
    },
    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                try {
                    const response = await ApplicationFormService.saveStep10(this.dataFormStep10);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/thankful-page';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
        updateForm(dataAdditionalQuestionForm) {
            this.dataFormStep10 = dataAdditionalQuestionForm;
        }
    }
}
</script>

<style scoped>

</style>
